import { isNativeApp } from "@benefit-systems/webview/utils";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { useSelector } from "react-redux";

import { nativeGTMKey } from "web/constants/native";

import useCtaButtonGtmClickTracking from "web/hooks/useCtaButtonGtmClickTracking";

const Gtm = () => {
  const { gtm_api_key: webGTMKey, gtm_api_enable: isEnabled } = useSelector(
    (state) => state.app.storeConfig
  );

  useCtaButtonGtmClickTracking(!!isEnabled);

  useEffect(() => {
    if (TagManager && isEnabled) {
      TagManager.initialize({
        gtmId: isNativeApp() ? nativeGTMKey : webGTMKey,
      });
    }
  }, [TagManager, webGTMKey, isEnabled]);

  return null;
};

export default Gtm;
